import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SiteLayout from './layouts/SiteLayout';
import Home from './pages/Home';
import Services from './pages/Services';
import Solutions from './pages/Solutions';
import Resources from './pages/Resources';
import SupportContact from './pages/SupportContact';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import WindshieldRepair from './pages/services/WindshieldRepair';
import WindshieldReplacement from './pages/services/WindshieldReplacement';
import SideGlass from './pages/services/SideGlass';
import RoofBackGlass from './pages/services/RoofBackGlass';
import ADASCalibrations from './pages/services/ADASCalibrations';
import DiagnosticsCoding from './pages/services/DiagnosticsCoding';

export default function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route element={<SiteLayout />}>
					<Route index element={<Home />} />
					<Route path="services" element={<Services />} />
					<Route path="services/windshield-repair" element={<WindshieldRepair />} />
					<Route path="services/windshield-replacement" element={<WindshieldReplacement />} />
					<Route path="services/side-glass" element={<SideGlass />} />
					<Route path="services/roof-back-glass" element={<RoofBackGlass />} />
					<Route path="services/adas-calibrations" element={<ADASCalibrations />} />
					<Route path="services/diagnostics-coding" element={<DiagnosticsCoding />} />
					<Route path="solutions" element={<Solutions />} />
					<Route path="resources" element={<Resources />} />
					<Route path="support" element={<SupportContact />} />
					<Route path="contact" element={<SupportContact />} />
					<Route path="about" element={<About />} />
					<Route path="privacy" element={<Privacy />} />
					<Route path="terms" element={<Terms />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
}
